import { Icons } from '@commercetools-docs/ui-kit';

export default Icons.HttpApiSmallSvgIcon;
